import { render, staticRenderFns } from "./VideoParticipant.vue?vue&type=template&id=56d50acc&"
import script from "./VideoParticipant.vue?vue&type=script&lang=js&"
export * from "./VideoParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports